(() => {
  const qs = (sel, root = document) => root.querySelector(sel);
  const qsa = (sel, root = document) => [...root.querySelectorAll(sel)];

  const setOpen = (el, open) => {
    if (!el) return;
    el.hidden = !open;
    const anyOpen = qsa('.jba-drawer, .jba-search').some((node) => !node.hidden);
    document.body.style.overflow = anyOpen ? 'hidden' : '';
  };

  const toggle = (el, open) => setOpen(el, open);

  qsa('[data-menu-toggle]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const nav = qs('[data-mobile-nav]');
      const open = nav.hidden;
      toggle(nav, open);
      btn.setAttribute('aria-expanded', String(open));
    });
  });
  qsa('[data-menu-close]').forEach((btn) => {
    btn.addEventListener('click', () => {
      toggle(qs('[data-mobile-nav]'), false);
      qs('[data-menu-toggle]')?.setAttribute('aria-expanded', 'false');
    });
  });

  qsa('[data-search-open]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const modal = qs('[data-search-modal]');
      toggle(modal, true);
      qs('#JbaSearch', modal)?.focus();
    });
  });
  qsa('[data-search-close]').forEach((btn) => {
    btn.addEventListener('click', () => toggle(qs('[data-search-modal]'), false));
  });

  qsa('[data-wishlist-open]').forEach((btn) => {
    btn.addEventListener('click', () => toggle(qs('[data-wishlist-drawer]'), true));
  });
  qsa('[data-wishlist-close]').forEach((btn) => {
    btn.addEventListener('click', () => toggle(qs('[data-wishlist-drawer]'), false));
  });

  const cartDrawer = qs('[data-cart-drawer]');
  const openCart = () => toggle(cartDrawer, true);
  const closeCart = () => toggle(cartDrawer, false);
  qsa('[data-cart-open]').forEach((btn) => btn.addEventListener('click', openCart));
  qsa('[data-cart-close]').forEach((btn) => btn.addEventListener('click', closeCart));

  const money = (cents) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'USD'
      }).format(cents / 100);
    } catch (e) {
      return `$${(cents / 100).toFixed(2)}`;
    }
  };

  const paintBagCount = (count) => {
    qsa('[data-cart-count]').forEach((el) => { el.textContent = count; });
  };

  const paintCartFromJson = (cart) => {
    paintBagCount(cart.item_count);
    if (cart.item_count <= 0) return;

    const totalHtml = `<span class="jba-cart-drawer__price-amount">${money(cart.total_price)}</span>`;
    qsa('[data-cart-subtotal], [data-cart-total]').forEach((el) => {
      el.innerHTML = totalHtml;
    });

    const summary = qs('[data-cart-summary]');
    if (!summary) return;

    const discount = Number(cart.total_discount || 0);
    if (cart.item_count >= 2 && discount > 0) {
      summary.innerHTML = `
        <div class="jba-cart-drawer__summary">
          <div class="jba-cart-drawer__summary-row">
            <span>Subtotal</span>
            <span data-cart-original>${money(cart.original_total_price)}</span>
          </div>
          <div class="jba-cart-drawer__summary-row jba-cart-drawer__summary-row--discount">
            <span>10% off (2+ pieces)</span>
            <span data-cart-discount>−${money(discount)}</span>
          </div>
        </div>`;
    } else if (cart.item_count === 1) {
      summary.innerHTML = `
        <p class="jba-cart-drawer__offer-hint" data-cart-offer-hint>
          Add 1 more piece for <strong>10% off</strong>
        </p>`;
    } else {
      summary.innerHTML = '';
    }
  };

  const refreshCart = async () => {
    const [sectionRes, cartRes] = await Promise.all([
      fetch(`${window.Shopify?.routes?.root || '/'}?section_id=cart-drawer`),
      fetch(`${window.Shopify?.routes?.root || '/'}cart.js`)
    ]);
    const html = await sectionRes.text();
    const cart = await cartRes.json();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const next = doc.querySelector('[data-cart-drawer-content]');
    const current = qs('[data-cart-drawer-content]');
    if (next && current) current.innerHTML = next.innerHTML;
    paintCartFromJson(cart);
  };

  let cartBusy = false;
  const changeLine = async (row, quantity) => {
    const lineNum = Number(row?.getAttribute('data-line'));
    const nextQty = Number(quantity);
    if (!lineNum || !row || cartBusy) return;

    // Optimistic UI — feels instant
    const prevQty = Number(row.getAttribute('data-qty')) || 0;
    row.setAttribute('data-qty', String(nextQty));
    const valEl = row.querySelector('[data-cart-qty-value]');
    if (valEl) valEl.textContent = String(nextQty);
    const bag = qs('[data-cart-count]');
    const bagNow = Number(bag?.textContent || 0);
    paintBagCount(Math.max(0, bagNow + (nextQty - prevQty)));
    if (nextQty <= 0) row.style.opacity = '0.4';

    cartBusy = true;
    try {
      const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: lineNum, quantity: nextQty })
      });
      if (!res.ok) {
        await refreshCart();
        return;
      }
      const cart = await res.json();
      if (cart.item_count === 0 || nextQty <= 0) {
        await refreshCart();
        return;
      }
      paintCartFromJson(cart);
    } catch (e) {
      await refreshCart();
    } finally {
      cartBusy = false;
    }
  };

  cartDrawer?.addEventListener('click', (event) => {
    const noteSave = event.target.closest('[data-cart-note-save]');
    if (noteSave && cartDrawer.contains(noteSave)) {
      event.preventDefault();
      const note = qs('[data-cart-note]', cartDrawer)?.value || '';
      fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note })
      }).then(() => {
        const details = noteSave.closest('details');
        if (details) details.open = false;
      }).catch(() => {});
      return;
    }

    const target = event.target.closest(
      '[data-cart-qty-minus], [data-cart-qty-plus], [data-cart-remove], [data-cart-close]'
    );
    if (!target || !cartDrawer.contains(target)) return;
    event.preventDefault();

    if (target.hasAttribute('data-cart-close')) {
      closeCart();
      return;
    }

    const row = target.closest('[data-cart-line]');
    if (!row) return;

    const current = Number(row.getAttribute('data-qty'));
    if (Number.isNaN(current)) return;

    if (target.hasAttribute('data-cart-remove')) {
      changeLine(row, 0);
      return;
    }
    if (target.hasAttribute('data-cart-qty-minus')) {
      // Never remove via minus — stay at 1; use Remove to delete
      if (current <= 1) return;
      changeLine(row, current - 1);
      return;
    }
    if (target.hasAttribute('data-cart-qty-plus')) {
      changeLine(row, current + 1);
    }
  });

  const form = qs('[data-product-form]');
  if (form) {
    const sectionRoot = form.closest('[data-product-section]');
    const variantInput = qs('[data-variant-id]', form);
    const jsonEl = qs('[data-variant-json]', form);
    const variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];
    const addButtons = qsa('[data-add-to-cart]', sectionRoot || document);

    const selectedOptions = () =>
      qsa('[data-option-index]', form)
        .filter((el) => el.tagName === 'SELECT' || (el.type === 'radio' && el.checked))
        .sort((a, b) => Number(a.dataset.optionIndex) - Number(b.dataset.optionIndex))
        .map((el) => el.value);

    const money = (cents) => {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: window.Shopify?.currency?.active || 'USD'
        }).format(cents / 100);
      } catch (e) {
        return `$${(cents / 100).toFixed(2)}`;
      }
    };

    const renderPrice = (variant) => {
      qsa('[data-product-price]', sectionRoot || document).forEach((el) => {
        const onSale = variant.compare_at_price > variant.price;
        const compare = onSale
          ? `<s class="price__compare">${money(variant.compare_at_price)}</s>`
          : '';
        el.classList.toggle('is-sale', onSale);
        el.innerHTML = `<div class="price"><span class="price__regular">${money(variant.price)}</span>${compare}</div>`;
      });
    };

    const syncVariant = () => {
      if (!variants.length) return;
      const opts = selectedOptions();
      const match = variants.find((v) => v.options.every((opt, i) => opt === opts[i]));
      if (!match) return;
      variantInput.value = match.id;
      addButtons.forEach((submit) => {
        submit.disabled = !match.available;
        submit.textContent = match.available
          ? submit.dataset.addLabel || 'Add to bag'
          : 'Sold out';
      });
      const stock = qs('[data-pdp-stock]', sectionRoot);
      if (stock) {
        stock.textContent = match.available
          ? 'This item is currently in stock.'
          : 'This item is currently unavailable.';
        stock.classList.toggle('is-in-stock', match.available);
      }
      renderPrice(match);
    };
    form.addEventListener('change', syncVariant);

    const qtyWrap = qs('[data-qty]', form);
    const qtyInput = qs('[name="quantity"]', form);
    if (qtyWrap && qtyInput) {
      qs('[data-qty-minus]', qtyWrap)?.addEventListener('click', () => {
        qtyInput.value = Math.max(1, Number(qtyInput.value || 1) - 1);
      });
      qs('[data-qty-plus]', qtyWrap)?.addEventListener('click', () => {
        qtyInput.value = Math.max(1, Number(qtyInput.value || 1) + 1);
      });
    }

    form.addEventListener('submit', async (event) => {
      if (document.body.dataset.cartType !== 'drawer') return;
      event.preventDefault();
      const data = new FormData(form);
      await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        body: data
      });
      await refreshCart();
      openCart();
    });
  }

  const gallery = qs('[data-pdp-gallery]');
  if (gallery) {
    const carousel = qs('[data-pdp-carousel]', gallery);
    const slides = qsa('.jba-pdp__slide', gallery);
    const thumbs = qsa('[data-pdp-thumb]', gallery);
    const goTo = (index) => {
      const slide = slides[index];
      if (!slide || !carousel) return;
      carousel.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      thumbs.forEach((t, i) => {
        t.classList.toggle('is-active', i === index);
        t.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    };
    thumbs.forEach((btn, index) => btn.addEventListener('click', () => goTo(index)));
    qs('[data-pdp-zoom]', gallery)?.addEventListener('click', () => {
      const active = thumbs.findIndex((t) => t.classList.contains('is-active'));
      const img = slides[Math.max(0, active)]?.querySelector('img');
      if (img) window.open(img.currentSrc || img.src, '_blank');
    });
    if (carousel && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const index = slides.indexOf(entry.target);
          if (index < 0) return;
          thumbs.forEach((t, i) => {
            t.classList.toggle('is-active', i === index);
            t.setAttribute('aria-current', i === index ? 'true' : 'false');
          });
        });
      }, { root: carousel, threshold: 0.6 });
      slides.forEach((slide) => io.observe(slide));
    }
  }

  const atc = qs('.jba-pdp__form [data-add-to-cart]');
  const bar = qs('[data-pdp-bar]');
  if (atc && bar && 'IntersectionObserver' in window) {
    const barIo = new IntersectionObserver((entries) => {
      bar.hidden = entries[0]?.isIntersecting !== false;
    }, { threshold: 0 });
    barIo.observe(atc);
  }


  qsa('[data-product-carousel]').forEach((root) => {
    const track = qs('[data-carousel-track]', root);
    if (!track) return;
    const step = () => {
      const card = track.querySelector('.jba-card');
      if (!card) return Math.max(track.clientWidth * 0.8, 1);
      const styles = getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return card.getBoundingClientRect().width + gap;
    };
    qs('[data-carousel-prev]', root)?.addEventListener('click', () => {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    qs('[data-carousel-next]', root)?.addEventListener('click', () => {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });
  });

  qsa('.jba-drawer, .jba-search').forEach((overlay) => {
    overlay.addEventListener('click', (event) => {
      if (event.target !== overlay) return;
      setOpen(overlay, false);
      qs('[data-menu-toggle]')?.setAttribute('aria-expanded', 'false');
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    toggle(qs('[data-mobile-nav]'), false);
    toggle(qs('[data-search-modal]'), false);
    toggle(qs('[data-wishlist-drawer]'), false);
    closeCart();
  });
})();
